import React, { useState, useEffect } from 'react';
import { TextField, Button, Autocomplete, FormControl, FormHelperText, div } from '@mui/material';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Country } from 'country-state-city';
import { toast } from 'react-hot-toast';
import { editMyProfileDetails, fetchMyProfileData } from '../../redux/myProfileSlice';
import SuccessModal from '../../components/Modals/SuccessfulModal';

const EDIT_MY_PROFILE_VALIDATIONS
    = yup.object({
        url: yup.string()
            .url('Invalid URL format. Example: https://www.example.com'),
        additionalPhone: yup.string()
            .matches(/^[0-9]+$/, 'Phone number must only contain digits.')
            .min(8, 'Phone number is too short.')
            .max(15, 'Phone number is too long.'),
        additionalEmail: yup.string()
        .email('Invalid email format. Example: example@example.com'),
        gst: yup.string()
        .matches(/^[a-zA-Z0-9]{5,15}$/, 'Invalid tax ID format. It should be alphanumeric and between 5 to 15 characters.'),
    });

const MyProfileEditPage = ({ onSubmit, handleStepChange, currentStep }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    // const { loading } = useSelector((state) => state.myProfile.myProfileDetails);
    const userDetails = useSelector(state => state.auth.userDetails) || {}
    const [countries, setCountries] = useState([]);
    const myProfileData = useSelector((state) => state.myProfile.myProfileData);
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.mp4)$/i;
    const [bannerImagePath, setBannerImagePath] = useState()
    const [fileUrl, setFileUrl] = useState("")
    const imageUrl = 'http://localhost:3200/' + bannerImagePath // TODO TEMPORARY IMAGE UPLOAD 
    const [buttonDisabled, setButtonDisabled] = useState(true)
    const [imageLoading, setImageLoading] = useState(true)
    const [imageError, setImageError] = useState("")
    const [isEdit, setIsEdit] = useState(false)
    const { ...rest } = useSelector((state) => state.myProfile.myProfileData);
    useEffect(() => {
        setCountries(Country.getAllCountries().map(({ phonecode, name }) => ({ code: phonecode, name })));
    }, []);
    useEffect(() => {
        const companyId = userDetails?.company?.companyKeyId;
        const url = `/companies/${companyId}`;
        const certificateUrl = `/companies/${companyId}`
        if (companyId) {
            dispatch(fetchMyProfileData(url)).then(() => {
            });
        }
    }, [dispatch]);
    const handleImageChange = (e) => {
        // if (e.target.files[0]) {
        //     setFileUrl(URL.createObjectURL(e.target.files[0]));
        //     setFile(e.target.files[0])
        // }
        // setButtonDisabled(false)
    }
    const handleImageUpload = async (event) => {
        // event.preventDefault()
        // setImageLoading(true)
        // const formData = new FormData()
        // formData.append("image", file)
        // try {
        //     const result = await uploadBanner(formData)
        //     setBannerImagePath(result.data.filePath)
        //     setError(false)
        //     setImageError("")
        //     setErrorMessage("")
        // }
        // catch (err) {
        //     setError(true)
        //     setErrorMessage(err.response.data.msg)
        // }
        // setImageLoading(false)
    }
    const handleEditMyProfileSubmit = (formattedValues) => {
        dispatch(editMyProfileDetails({ editedMyProfileData: formattedValues }))
        .then((response) => {
            const companyDetails = response.payload
            toast.success(response.payload.msg);
            if (companyDetails.success === true) {
            setIsEdit(true)
            }
          })
          .catch((error) => {
            console.error("Fetching user details error:", error);
          });
    }
    return (
        <>
            <div>
                <h1 className="fprimary">Edit My Profile </h1>
                <h5 className="">Edit carefully My Profile details</h5>
            </div>
            <div className="card mt-3 bg-stage">
                <div className="card-body">
                    <div className='row'>
                        <div className="col-md-2">
                            <h1 className="fprimary">Company Details&nbsp;&nbsp;</h1>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Company Name</p>
                                    <div className="bg-slash font-14">{myProfileData.companyName}</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 pe-2">
                                    <p className="font-13 mb-0">Company Name</p>
                                    <div className="bg-slash font-14">{myProfileData.companyTypeName}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Contact Details */}
                <div className="card-body">
                    <div className='mb-2'>
                        <h1 className="fprimary">Contact Details&nbsp;&nbsp;</h1>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Mobile No.</p>
                                    <div className="bg-slash font-14">{myProfileData?.phoneNumber || '-'}</div>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Email-id</p>
                                    <div className="bg-slash font-14">{myProfileData?.emailAddress || '-'}</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className='mb-2'>
                        <h1 className="fprimary">Location &nbsp;&nbsp;</h1>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-2">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Country</p>
                                    <div className="bg-slash font-14">{myProfileData.country}</div>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">State</p>
                                    <div className="bg-slash font-14">{myProfileData.state}</div>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">City</p>
                                    <div className="bg-slash font-14">{myProfileData.city}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Pincode</p>
                                    <div className="bg-slash font-14">{myProfileData.zip}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Address</p>
                                    <div className="bg-slash font-14">{myProfileData?.address || '-'}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Formik
                    initialValues={{
                        url: myProfileData.url || '',
                        phoneNumber: myProfileData.phoneNumber || '',
                        emailAddress: myProfileData.emailAddress || '',
                        gst: myProfileData?.gst || '',
                        additionalIsdCode: myProfileData?.additionalIsdCode || '',
                        additionalPhone: myProfileData?.additionalPhone || '',
                        isdCode: myProfileData?.isdCode || '',
                        ...rest,
                    }}
                    enableReinitialize={true}
                    validationSchema={EDIT_MY_PROFILE_VALIDATIONS}
                    onSubmit={(values, { setSubmitting }) => {
                        const formattedValues = {
                            ...values
                        };
                        handleEditMyProfileSubmit(formattedValues);
                        // dispatch(editMyProfileDetails({ editedMyProfileData: formattedValues }));
                        onSubmit(formattedValues);
                        setSubmitting(false);
                    }}
                >
                    {formikProps => {
                        const {
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                        } = formikProps;
                        return (
                            <Form>
                                <div className="row m-3">
                                    <div className="col-md-4 cs-form mb-3">
                                        <TextField
                                            label={'Company URL'}
                                            className='md-input'
                                            name='url'
                                            value={values.url}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.url}
                                            helperText={errors.url}
                                            inputProps={{
                                                maxLength: 500,
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-1 cs-form mb-3">
                                        <FormControl fullWidth>
                                            <Autocomplete
                                                id="country-select"
                                                className='md-input'
                                                name='additionalIsdCode'
                                                options={countries}
                                                value={countries.find(country => country.code === values.additionalIsdCode) || null}
                                                onChange={(event, newValue) => {
                                                    setFieldValue('additionalIsdCode', newValue ? newValue.code : '');
                                                }}
                                                getOptionLabel={(option) => option.code}
                                                label="Additional ISD"
                                                renderInput={(params) => <TextField {...params} label="Additional ISD" variant="outlined" />}
                                            />
                                        </FormControl>
                                    </div>
                                    <div className="col-md-3 cs-form mb-3">
                                        <TextField
                                            label={'Additional Phone'}
                                            className='md-input'
                                            name='additionalPhone'
                                            value={values.additionalPhone}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.additionalPhone}
                                            helperText={errors.additionalPhone}
                                            inputProps={{
                                                maxLength: 20,
                                            }}
                                        />
                                    </div>
                                    <div className="col-md-3 cs-form mb-3">
                                        <TextField
                                            label={'Additional Email'}
                                            className='md-input '
                                            name='additionalEmail'
                                            value={values.additionalEmail}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.additionalEmail}
                                            helperText={errors.additionalEmail}
                                            inputProps={{
                                                maxLength: 500,
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row m-3">
                                    <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            label={'Awards'}
                                            className='md-input'
                                            name='awards'
                                            value={values.awards}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            // error={errors.}
                                            // helperText={errors.}
                                        inputProps={{
                                            maxLength: 500,
                                        }}
                                        />
                                    </div>
                                    <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            label={'GST / VAT / Tax Id'}
                                            className='md-input'
                                            name='gst'
                                            value={values.gst}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.gst}
                                            helperText={errors.gst}
                                            inputProps={{
                                                maxLength: 100,
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row m-3">
                                    <div className="banner_padding">
                                        <p className="banner_heading_text">Featured Image</p>
                                        <input type="file" onChange={handleImageChange} />
                                        <img src={fileUrl.length > 0 ? fileUrl : imageUrl} accept="image/*" alt="" style={{
                                            width: '80px',
                                            height: '68px',
                                            borderRadius: '12px',
                                            marginLeft: '10px',
                                            marginRight: '25px'
                                        }} />
                                        <button
                                            type="submit"
                                            disabled={buttonDisabled}
                                            className={!buttonDisabled ? "btn btn-primary greeen-btn md_btn" : "btn btn-secondary md_btn"} style={{
                                                margin: "10px",
                                                width: '116px'
                                            }}
                                            onClick={handleImageUpload}>
                                            <span><i className="mdi mdi-plus-circle-outline"></i>Upload</span>
                                        </button>
                                        {!imageLoading ? (error ? <div className="text-warning">{errorMessage}</div> : <div className="text-success">Upload Success</div>)
                                            : <div></div>}
                                        {imageError.length > 0 ? <div className=" text-warning">{imageError}</div> : null}
                                    </div>
                                </div>
                                <div className="row m-3">
                                    <div className="col-md-12 cs-form mb-3">
                                        <TextField
                                            label={'Company Description'}
                                            className='md-input'
                                            name='description'
                                            multiline
                                            rows={4}
                                            value={values.description}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            // error={errors.description}
                                            // helperText={errors.description}
                                            inputProps={{
                                                maxLength: 500,
                                            }}
                                            helperText={`${values.description.length}/500`}
                                        />
                                    </div>
                                    <div className="d-flex justify-content-between mt-3">
                                        <button type="button" className="btn btn-light grey-btn lg-btn"
                                            onClick={(() => navigate(-1))}>
                                            Back
                                        </button>
                                        <div>
                                            <button type="submit" className="btn btn-primary greeen-btn lg-btn lg-btn"
                                                variant="contained"
                                            // onClick={handleSubmit}
                                            // disabled={loading}
                                            >
                                                {/* {loading ? 'Submitting...' : 'Submit'} */}
                                                {'Submit'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Form>)
                    }}
                </Formik >
                {isEdit &&
                    <SuccessModal
                        isOpen={isEdit}
                        msg={"Updated Successfully!"}
                        navigatePage={'/my-profile'}
                    />
                }
            </div>

        </>
    );
};

export default MyProfileEditPage;